import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import InputControl from '~/components/Input/InputControl';
import InputSelectAsync   from '~/components/Input/InputSelectAsync';
import isObject from '~/utils/isObject';
import { editFilter } from '../../../../store/actions';

const getInicialValue = (value) => {
  if( isObject(value) && value.id && value.name ){
    return value;
  } else if( value ){
    return { id: value, name: 'Carregando...' };
  }
  return null;
};

function InputAsync(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    filter,
    indexGroup,
    indexFilter,
    inputProps,
    asyncFetch,
    asyncShow,
    ...ownProps
  } = props;

  const [value, setValue] = useState( getInicialValue(filter.get('value')) );

  const handleUpdate = ({value}) => {
    dispatch(editFilter(indexGroup, indexFilter, 'value', value));
  };

  useEffect(() => {
    if(value){
      asyncShow(value.id).then(setValue);
    }
  }, []);

  useEffect(() => {
    setValue( getInicialValue(filter.get('value')) );
  }, [filter.get('value')]);

  return (
    <InputControl
      value={value}
      name={'value'}
      inputComponent={InputSelectAsync}
      InputProps={{
        placeholder: t('filter-label-value'),
        isClearable: false,
        handleFetch: asyncFetch,
        createEnabled: false,
        error: false,
        ...inputProps,
      }}
      onChange={handleUpdate}
      {...ownProps}
      autoComplete={false}
    />
  );
}

export default React.memo(InputAsync);